// @ts-ignore
import { SUBJECTS_SLUGS } from '@yandex-int/k-common/constants';
import { LessonSubscription } from '@yandex-int/k-common/typings';
import { createSelector } from 'reselect';

import { getDeletingCLessonId } from 'common.components/lesson/selectors';
import { getCourseActiveSubscriptions } from 'store/subscriptions/selectors';
import { getClessonIdFromProps, getSubjectFromProps } from 'utils/selectors/selectors';

interface PropsWithSubscriptions {
    subscriptions?: Array<LessonSubscription>;
}

const getLessonSubscriptionFromProps = (_storeState: any, ownProps: PropsWithSubscriptions) => {
    if (ownProps && ownProps.subscriptions) {
        return ownProps.subscriptions;
    }

    return null;
};

export const getShouldDisableCLesson = createSelector(
    [getDeletingCLessonId, getClessonIdFromProps],
    (deletingCLessonId, clessonId): boolean => clessonId === deletingCLessonId
);

export const getShouldShowLessonMeta = createSelector(
    [getSubjectFromProps],
    (subject: SUBJECTS_SLUGS): boolean => subject === SUBJECTS_SLUGS.informatics
);

export const getActiveSubscriptionSlug = createSelector(
    [getLessonSubscriptionFromProps, getCourseActiveSubscriptions],
    (lessonSubscriptions, courseSubscriptions) => {
        const lessonSubscriptionsSlugs = lessonSubscriptions?.map((sub) => sub.subscription.slug) || [];
        const activeSubscriptionsSlugs = courseSubscriptions.map((sub) => sub.subscription.slug);

        return lessonSubscriptionsSlugs.find((slug) => activeSubscriptionsSlugs.includes(slug)) || null;
    }
);
